module.exports = __webpack_public_path__ + "img/app-store.8bb99c72.png";